import { c as create_ssr_component, f as createEventDispatcher, v as validate_component } from "./ssr.js";
import { S as Search } from "./Search.js";
import "./client.js";
const SearchFilter = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  createEventDispatcher();
  let value = "";
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    $$rendered = `<div class="relative "><div class="flex gap-3 items-center">${validate_component(Search, "Search").$$render(
      $$result,
      {
        placeholder: "Suche...",
        class: "flex-1",
        value
      },
      {
        value: ($$value) => {
          value = $$value;
          $$settled = false;
        }
      },
      {}
    )} ${slots.cta ? slots.cta({}) : ``}</div></div>`;
  } while (!$$settled);
  return $$rendered;
});
export {
  SearchFilter as S
};
//# sourceMappingURL=SearchFilter.js.map
